import { render, staticRenderFns } from "./EimzaGate.vue?vue&type=template&id=2113a7f8&"
import script from "./EimzaGate.vue?vue&type=script&lang=js&"
export * from "./EimzaGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports